import * as actionTypes from '../actions/actionTypes';

const initialState = {
    credits: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.RETRIEVE_CREDITS_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                credits: null
            };
        case actionTypes.RETRIEVE_CREDITS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                credits: null
            };
        case actionTypes.RETRIEVE_CREDITS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                credits: null
            };
        case actionTypes.RETRIEVE_CREDITS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                credits: action.payload
            };
        default:
            return state;
    }
};

export default reducer;